import React, { useEffect, useState } from "react";
import {
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Checkbox,
  Grid,
  FormGroup,
  FormControlLabel,
  Button,
  Menu,
  MenuItem,
  Pagination,
  Select,
  useMediaQuery,
} from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import Norecords from "../../components/customHelpers/Norecords";
import Notify from "../../components/customHelpers/Notify";
import Loading from "../../components/customHelpers/Loading";
import SearchIcon from "@mui/icons-material/Search";
import Order from "../../actions/order";
import CancelIcon from "@mui/icons-material/Cancel";

import Notification from "../../components/customHelpers/Notification";
import {
  calculateTotalPaid,
  calculateTotalSumOrderProducts,
  formatNumber,
  getTimestamp,
  pageSizes,
} from "../../utils/utils";
import Product from "../../actions/product";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import useTable from "../../components/customHelpers/usePaginationTable";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import FilterExportButtons from "./filterExportButton";
const initialHeadCells = [
  { id: "customer", label: "Customer", isVisible: true },
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "discount", label: "Discount", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "date", label: "Date", isVisible: true },
];
const PendingOrderProducts = ({ status }) => {
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const [orderProducts, setOrderProducts] = useState([]);
  const [productLists, setProductLists] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { viewAllProductsLists } = Product();
  const [searchTerm, setSearchTerm] = useState("");
  const [inputValue, setInputValue] = useState("");
  const { NotifyMessage, notify, setNotify } = Notify();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { viewAllOrderProductsWithPages, viewOrderProductsPrice } = Order();
  const [totals, setTotals] = useState({
    totalPrice: 0,
    totalQuantity: 0,
    isClick: true,
  });
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const options = productLists.map((product) => ({
    label: `${product.product.sku} - ${product.product.name} - ${product.store?.locationName}`,
    product,
  }));
  const { loading, reload } = values;
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  useEffect(() => {
    getAllOrders();
  }, [page, limit, searchQuery, selectedProduct, startDate, endDate, status]);
  useEffect(() => {
    getProductData();
    getTotalPrice();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedProduct, startDate, endDate, status]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getTotalPrice = () => {
    viewOrderProductsPrice(
      selectedProduct?.product.product.sku,
      startDate,
      endDate,
      status
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        setTotals({
          totalPrice: data.totalPrice || 0,
          totalQuantity: data.totalQuantity || 0,
          isClick: true,
        });
      }
    });
  };
  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };
  const handleSearchChange = (event, value) => {
    setPage(1);
    if (value) {
      setSelectedProduct(value);
      setTotals({ ...totals, isClick: true });
    }
  };
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewAllOrderProductsWithPages(
      page,
      limit,
      selectedProduct?.product.product.sku,
      startDate,
      endDate,
      status
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setOrderProducts(data.orders);

        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const getProductData = () => {
    viewAllProductsLists().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product);
      }
    });
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const headers = filteredHeadCells.map((cell) => cell.label);
    const data = [];

    orderProducts.forEach((order) => {
      const rowData = filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return order.order.customer.fullName;
          case "name":
            return order.productName;
          case "sku":
            return order.sku;
          case "price":
            return order.price;
          case "quantity":
            return order.quantity;
          case "discount":
            return order.discount;
          case "totalPrice":
            return formatNumber(order.totalPrice);
          case "date":
            return new Date(order.createdAt).toLocaleString();
          default:
            return "";
        }
      });
      data.push(rowData);
    });
    let totalPrice = 0;
    for (const op of orderProducts) {
      totalPrice += parseFloat(op.totalPrice || 0);
    }
    data.push([
      "Total Price",
      formatNumber(totalPrice),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const sku = selectedProduct ? selectedProduct.product.product.sku : "";
    const filename = generateReportFilename(startDate, endDate, sku, timestamp);
    saveAs(blob, filename);
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const headers = [filteredHeadCells.map((cell) => cell.label)];
    const data = [];
    orderProducts.forEach((op) => {
      const rowData = filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return op.order.customer.fullName;
          case "name":
            return op.productName;
          case "sku":
            return op.sku;
          case "price":
            return op.price;
          case "quantity":
            return op.quantity;
          case "discount":
            return op.discount;
          case "date":
            return new Date(op.createdAt).toLocaleString();
          case "totalPrice":
            return formatNumber(op.totalPrice);
          default:
            return "";
        }
      });
      data.push(rowData);
    });

    doc.autoTable({
      head: headers,
      body: data,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });
    let totalPrice = 0;

    for (const op of orderProducts) {
      totalPrice += parseFloat(op.totalPrice || 0);
    }

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${formatNumber(totalPrice)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const sku = selectedProduct ? selectedProduct.product.product.sku : "";
    const filename = generateReportFilename(startDate, endDate, sku, timestamp);
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const generateReportFilename = (startDate, endDate, sku, timestamp) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedSKU = sku || "AllSKUs";

    return `${formattedStartDate}_${formattedEndDate}_${formattedSKU}_Sales-order-detail-report_${timestamp}`;
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const clearFilters = () => {
    setSearchTerm("");
    setSelectedProduct(null);
    setFilteredOrders([]);
    setInputValue("");
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    setLimit(25);
    setTotals({ ...totals, isClick: true });
  };
  const handlePageChange = (event, newPage) => {
    setTotals({ ...totals, isClick: true });
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(orderProducts, initialHeadCells, filterFn);
  const theme = useTheme();
  const ismedium = useMediaQuery("(min-width:650px) and (max-width:1100px)");

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="start"
        gap={2}
        m={1}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Order Start Date"
            value={startDate}
            onChange={setStartDate}
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
              },
            }}
            sx={{
              width: { xs: "100%", sm: ismedium ? "30%" : "20%" },
              "& .MuiInputBase-root": { height: 45 },
            }}
          />

          <DatePicker
            label="Order End Date"
            value={endDate}
            onChange={setEndDate}
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
              },
            }}
            sx={{
              width: { xs: "100%", sm: ismedium ? "30%" : "20%" },
              "& .MuiInputBase-root": { height: 45 },
            }}
          />
        </LocalizationProvider>

        <Box sx={{ width: { xs: "100%", sm: ismedium ? "30%" : "20%" } }}>
          <Autocomplete
            options={searchTerm ? filteredOptions : []}
            fullWidth
            getOptionLabel={(option) => option.label}
            onChange={handleSearchChange}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            value={selectedProduct}
            inputValue={inputValue}
            renderInput={(params) => (
              <TextField
                {...params}
                label="SKU or Product Name"
                variant="outlined"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}
          />
        </Box>

        {!ismedium && (
          <FilterExportButtons
            clearFilters={clearFilters}
            exportToPDF={exportToPDF}
            exportToExcel={exportToExcel}
          />
        )}
      </Box>
      {ismedium && (
        <FilterExportButtons
          clearFilters={clearFilters}
          exportToPDF={exportToPDF}
          exportToExcel={exportToExcel}
        />
      )}
      <Grid container spacing={2}>
        {hiddenColumns.length > 0 && (
          <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
            <Typography variant="h6">Hidden Columns</Typography>
            <FormGroup sx={{ marginTop: 0 }}>
              {hiddenColumns.map((headCell, index) => (
                <FormControlLabel
                  key={headCell.id}
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          backgroundColor: "transparent",
                        },
                      }}
                      checked={!headCell.isVisible}
                      onChange={() => handleColumnToggle(headCell.id)}
                    />
                  }
                  label={headCell.label}
                  sx={{
                    marginBottom: index === hiddenColumns.length - 1 ? 0 : 1,
                    "& .MuiFormControlLabel-label": {
                      marginTop: 0,
                    },
                  }}
                />
              ))}
            </FormGroup>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={hiddenColumns.length > 0 ? 9 : 12}
          className="card__body"
        >
          {loading ? (
            <Loading />
          ) : (
            <Paper style={{ overflowX: "auto" }}>
              <TblContainer>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        height: "30px", // Set row height
                        maxHeight: "30px",
                        minHeight: "30px",
                      }}
                    >
                      {visibleColumns.map((headCell) => (
                        <TableCell
                          key={headCell.id}
                          className={
                            headCell.isVisible
                              ? "table-cell-visible"
                              : "table-cell-hidden"
                          }
                          sx={{
                            width: headCell.isVisible ? "auto" : "0",
                            fontWeight: 600,
                            color: theme.palette.secondary.main,
                            backgroundColor: theme.palette.primary.main,
                            fontSize: "1.3rem",
                            lineHeight: "1.2rem",
                            padding: "2px 4px",
                            height: "30px",
                            maxHeight: "30px",
                            minHeight: "30px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 0.5,
                              height: "100%",
                              "& .MuiSvgIcon-root": {
                                fontSize: "1rem", // Smaller icons
                              },
                            }}
                          >
                            <Typography
                              variant="body2"
                              noWrap
                              sx={{
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                lineHeight: "1rem",
                              }}
                            >
                              {headCell.label}
                            </Typography>

                            <Checkbox
                              checked={headCell.isVisible}
                              onChange={() => handleColumnToggle(headCell.id)}
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CancelIcon fontSize="small" />}
                              sx={{
                                p: 0,
                                m: 0,
                                "& .MuiSvgIcon-root": {
                                  fontSize: "1rem",
                                },
                              }}
                            />
                          </Box>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {recordsAfterSortingAndFiltering().length > 0 ? (
                      recordsAfterSortingAndFiltering().map((item) => (
                        <TableRow key={item.id}>
                          {visibleColumns.map((headCell) => (
                            <TableCell key={headCell.id}>
                              {headCell.id === "customer"
                                ? item.order?.customer.fullName
                                : headCell.id === "name"
                                ? item.productName
                                : headCell.id === "sku"
                                ? item.sku
                                : headCell.id === "price"
                                ? formatNumber(item.price)
                                : headCell.id === "quantity"
                                ? item.quantity
                                : headCell.id === "discount"
                                ? item.discount
                                : headCell.id === "totalPrice"
                                ? formatNumber(item.totalPrice)
                                : headCell.id === "date"
                                ? new Date(item.createdAt).toLocaleString()
                                : null}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                      <Norecords col={6} />
                    )}
                  </TableBody>
                </Table>
              </TblContainer>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  p: 2,
                  backgroundColor: "background.paper",
                  borderTop: 1,
                  borderColor: "divider",
                  gap: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                  <Typography variant="body2" sx={{ mr: 1 }}>
                    Rows per page:
                  </Typography>
                  <Select
                    value={limit}
                    onChange={handlePageSizeChange}
                    size="small"
                    sx={{ minWidth: 120 }}
                  >
                    {pageSizes.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
                {actualTotal && (
                  <span>
                    {" "}
                    {startIndex}-{endIndex} of {actualTotal}
                  </span>
                )}
                {orderProducts.length > 0 && (
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    hideNextButton={page === tot || orderProducts.length === 0}
                    hidePrevButton={page === 1}
                    shape="rounded"
                    siblingCount={1}
                    disabled={orderProducts.length === 0}
                  />
                )}
              </Box>{" "}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  flexDirection: "column",
                  p: 1,
                  gap: 1,
                  m: 1,
                  bgcolor: "background.paper",
                  borderRadius: 1,
                }}
              >
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Quantity: {formatNumber(totals.totalQuantity)}
                </div>
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Price: {formatNumber(totals.totalPrice)}
                </div>
              </Box>
            </Paper>
          )}
        </Grid>
        {hiddenColumns.length > 0 && (
          <Grid
            item
            xs={2}
            sx={{ display: { xs: "none", sm: "block" }, marginLeft: 10 }}
          >
            <Typography variant="h6">Hidden Columns</Typography>
            <Grid container spacing={1}>
              {hiddenColumns.map((headCell, index) => (
                <Grid item xs={6} key={headCell.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          "& .MuiSvgIcon-root": {
                            backgroundColor: "transparent",
                          },
                        }}
                        checked={!headCell.isVisible}
                        onChange={() => handleColumnToggle(headCell.id)}
                      />
                    }
                    label={headCell.label}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        marginTop: 0,
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
        <Notification notify={notify} setNotify={setNotify} />
      </Grid>
    </>
  );
};

export default PendingOrderProducts;
